/**CORE LIBRARIES IMPORT */
import React from "react";

/**DATA IMPORT */
import { brands } from "../data/brand";

/**
 * Renders an official logo unchanged. `size` is the rendered CSS width used
 * to pick the right file from srcSet. The Grey Wolf emblem is circular, so it
 * gets a circular mask over its plain black corners (artwork untouched).
 */
const BrandLogo = ({ brand = "greyWolf", size = 160, className = "", decorative = false, eager = false }) => {
  const logo = brands[brand];
  return (
    <img
      className={`brand-logo brand-logo-${brand} ${className}`}
      src={logo.src}
      srcSet={logo.srcSet}
      sizes={`${size}px`}
      width={logo.width}
      height={logo.height}
      alt={decorative ? "" : logo.alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
    />
  );
};

export default BrandLogo;
